// Hash routes (the site is static assets, so no server routing):
//   #/                          account home        #/new, #/new/fresh, #/new/firebase
//   #/p/<id>                    project overview    #/p/<id>/<product>/<tab>
//   #/p/<id>/settings/<tab>     project settings    #/admin/<page>/…     #/account
// Old dashboard links (#/mail, #/mail/templates, #/mail/brand/…, #/push) land on their admin pages.
import { useSyncExternalStore } from "react";

export interface Route {
  name: "home" | "new" | "project" | "admin" | "account" | "unknown";
  id?: string;
  product?: string;
  tab?: string;
  rest: string[];
}

const subscribe = (cb: () => void) => {
  window.addEventListener("hashchange", cb);
  return () => window.removeEventListener("hashchange", cb);
};

export function legacyRedirect(hash: string): string | null {
  if (hash === "#/mail") return "#/admin/mail";
  if (hash === "#/push") return "#/admin/push";
  if (hash.startsWith("#/mail/")) return `#/admin/mail/${hash.slice("#/mail/".length)}`;
  return null;
}

export function parse(hash: string): Route {
  const parts = hash.replace(/^#\/?/, "").split("/").filter(Boolean).map(decodeURIComponent);
  const [head, ...rest] = parts;
  if (!head) return { name: "home", rest: [] };
  if (head === "new") return { name: "new", rest };
  if (head === "account") return { name: "account", rest };
  if (head === "admin") return { name: "admin", product: rest[0] ?? "projects", tab: rest[1], rest: rest.slice(1) };
  if (head === "p" && rest[0]) return { name: "project", id: rest[0], product: rest[1] ?? "overview", tab: rest[2], rest: rest.slice(3) };
  return { name: "unknown", rest: parts };
}

export function useRoute(): Route {
  const hash = useSyncExternalStore(subscribe, () => location.hash);
  return parse(hash);
}

export const go = (hash: string) => {
  if (location.hash !== hash) location.hash = hash;
};
export const projectHref = (id: string, product?: string, tab?: string) =>
  `#/p/${encodeURIComponent(id)}${product && product !== "overview" ? `/${product}${tab ? `/${tab}` : ""}` : ""}`;
